import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { DealStatus as l, DealCardAction as c } from "../../../../types/Deal/index.js";
import { StampType as N } from "../../../../components/CouponStamp/index.js";
import { Container as V, HeaderContentContainer as j, CardClick as F, ContainerGrid as w, ImageWrapper as z, Image as H, Content as O, Info as W, StoreMobileLink as X, Title as q, Body as J, StampShareContainer as Q, Stamp as U, StoreTextFixedCard as Y, CustomDealStoreLabel as Z, BottomContent as $, FooterContentContainer as L, CashbackContentContainer as M, CashbackFooter as ee } from "./style.js";
import { DealCardShareButton as ae } from "../../DealShareButton/index.js";
import { Timestamp as te } from "../../Timestamp/index.js";
import { useTranslation as le } from "../../../../hooks/useTranslation/index.js";
import { CashbackTag as oe } from "../../../../components/CashbackTag/index.js";
import { ReactComponent as re } from "../../../../resources/graphics/cashback/cashback-icon.svg.js";
const ne = (o) => ({
  [l.ACTIVE]: "",
  [l.DELETED]: "label-by-status-deleted",
  [l.EXPIRED]: "label-by-status-expired",
  [l.MODERATED]: "label-by-status-moderated",
  [l.PENDING]: "label-by-status-pending"
})[o], ye = ({
  id: o,
  innerRef: D,
  className: f,
  title: m,
  value: A,
  status: b = l.ACTIVE,
  image: _,
  storeName: i,
  storeImage: x,
  storeLink: d = "",
  timestamp: v,
  timestampTitle: R,
  stampType: g = N.PRICE,
  bottomContent: h,
  headerContent: y,
  footerContent: p,
  storeSlug: I,
  dealUrl: B,
  isOnboardingCard: r,
  storeText: E,
  isFixedCard: s,
  locale: K,
  cashbackPercentage: k = 0,
  dispatch: n,
  keepMobileLayout: a = !1,
  ...P
}) => {
  const { t: u } = le("common"), C = b !== l.ACTIVE, S = d && i, G = S || s, T = C ? 0 : k;
  return /* @__PURE__ */ t(
    V,
    {
      ref: D,
      className: f,
      disableclick: r,
      "data-keep-mobile-layout": a,
      ...P,
      children: [
        y && /* @__PURE__ */ t(j, { children: [
          " ",
          y,
          " "
        ] }),
        /* @__PURE__ */ e(
          F,
          {
            onClick: () => n({
              payload: { id: o },
              type: c.ON_CARD_CLICK
            }),
            disableclick: r
          }
        ),
        /* @__PURE__ */ t(w, { "data-keep-mobile-layout": a, children: [
          /* @__PURE__ */ e(
            oe,
            {
              type: "supercashback",
              style: { position: "absolute", top: 16, zIndex: 3 },
              percentage: T
            }
          ),
          /* @__PURE__ */ e(
            z,
            {
              onClick: () => n({
                payload: { id: o },
                type: c.ON_IMAGE_CLICK
              }),
              disableclick: r,
              children: /* @__PURE__ */ e(
                H,
                {
                  alt: m,
                  src: _ || "",
                  isInactive: C,
                  errorImage: x,
                  inactiveLabel: u(ne(b)),
                  "data-keep-mobile-layout": a
                }
              )
            }
          ),
          /* @__PURE__ */ t(O, { "aria-disabled": C, children: [
            /* @__PURE__ */ t(W, { "data-keep-mobile-layout": a, children: [
              G && /* @__PURE__ */ e(
                X,
                {
                  onClick: () => n({
                    payload: { storeSlug: I },
                    type: c.ON_STORE_CLICK
                  }),
                  title: i,
                  url: d,
                  disablePointerEvents: r,
                  "data-keep-mobile-layout": a,
                  children: i
                }
              ),
              /* @__PURE__ */ e(te, { timestamp: v, timestampTitle: R }),
              /* @__PURE__ */ e(
                q,
                {
                  onClick: () => n({
                    payload: { id: o },
                    type: c.ON_TITLE_CLICK
                  }),
                  title: m,
                  url: B,
                  disablePointerEvents: r,
                  "data-keep-mobile-layout": a,
                  children: m
                }
              )
            ] }),
            /* @__PURE__ */ t(J, { "data-keep-mobile-layout": a, children: [
              /* @__PURE__ */ t(Q, { "data-keep-mobile-layout": a, children: [
                /* @__PURE__ */ e(U, { value: A, type: g }),
                !s && /* @__PURE__ */ e(
                  ae,
                  {
                    id: o,
                    dispatch: n,
                    locale: K
                  }
                )
              ] }),
              s && /* @__PURE__ */ e(Y, { "data-keep-mobile-layout": a, children: E }),
              S && /* @__PURE__ */ e(
                Z,
                {
                  name: i,
                  link: d,
                  text: E,
                  isOnboardingCard: r,
                  slug: I,
                  dispatch: n,
                  "data-keep-mobile-layout": a
                }
              )
            ] })
          ] }),
          h && /* @__PURE__ */ e($, { children: h })
        ] }),
        p && /* @__PURE__ */ e(L, { children: p }),
        /* @__PURE__ */ e(
          M,
          {
            "data-is-visible": !!T && !p,
            children: /* @__PURE__ */ t(ee, { children: [
              /* @__PURE__ */ e(re, {}),
              k,
              "% ",
              u("super-cashback-percentage-tag-text")
            ] })
          }
        )
      ]
    }
  );
};
export {
  ye as DealCard,
  ne as getLabelByStatus
};
